<template>
  <div>

    <nut-swiper direction="horizontal" :autoPlay="3000" :swiperData="imagesList" :canDragging="false" :paginationVisible="true" ref="demo2">
      <div v-for="(item,index) in imagesList" :key="index" class="nut-swiper-slide">
        <a v-if="item.url != ''" :href="item.url"><img :src="item.images[0].url" alt=""></a>
        <a v-else href="javaScript:;"><img :src="item.images[0].url" alt=""></a>
      </div>

    </nut-swiper>
    <!-- <img src="../assets/images/images/banner_bg.jpg" alt=""> -->
    <div class="nav">
      <nut-row :gutter="10">
        <nut-col :span="6">
          <div class="flex-content" @click="autoroad()">
            <img src="../assets/images/images/xianluchaxun.png" alt="">
            <p>线路查找</p>
          </div>
        </nut-col>
        <nut-col :span="6">
          <div class="flex-content flex-content-light" @click="roadvote">
            <img src="../assets/images/images/toupiao.png" alt="">
            <p>线路投票</p>

          </div>
        </nut-col>
        <nut-col :span="6">
          <div class="flex-content" @click="myroad()"> <img src="../assets/images/images/wodexianlu.png" alt="">
            <p>我的线路</p>
          </div>
        </nut-col>
        <nut-col :span="6">
          <div class="flex-content flex-content-light" @click="gift()"><img src="../assets/images/images/wodejiangpin.png" alt="">
            <p>我的奖品</p>
          </div>
        </nut-col>
      </nut-row>

    </div>
    <div class="main">
      <h3 class="tit">优质推荐</h3>
      <div class="box box3">
        <div>
          <div class="li" :span="12" v-for="(item,index) in tuijian" :key="index">
            <div class="flex-content" @click="toH5(item.url)">
              <img :src="item.imgurl[0].url" alt="" height="103">
              <p>{{item.title}}</p>
            </div>
          </div>

        </div>
      </div>

      <div class="box2">
        <ul>
          <li @click="autoroad()">
            <div class="img"><img src="../assets/images/images/zhinengdingzhi.png" alt=""></div>
            <p>智能定制</p>
          </li>
          <li @click="makeroad()">
            <div class="img"><img src="../assets/images/images/shoudongdingzhi.png" alt=""></div>
            <p>手动定制</p>
          </li>
        </ul>
      </div>
      <h3 class="tit" ref="votetitle">线路投票</h3>
      <div class="box box1">
        <div class="titlist auto">
          <div class="search">
            <nut-textinput class="my-input" type="search" v-model="search.name" placeholder="搜索姓名" ref="myInput" @keyup.enter="submitSearch" />
            <nut-cell @click.native="openSwitch('isVisible')" :desc="option">
            </nut-cell>
            <nut-picker title="选择主题" :is-visible="isVisible" :list-data="listData" @close="closeSwitch('isVisible')" @confirm="confirm"></nut-picker>
            <div class="searchBtn" @click="submitSearch">搜索</div>
          </div>
          <!-- <span @click="themelist('')" :class="currtheme==''?'on':''">全部</span>
          <span @click="themelist(item.dictext)" :class="item.dictext==currtheme?'on':''" v-for='(item,i) in address.theme' :key="i">{{item.dictext}}</span> -->
        </div>
        <div class="roadlist">
          <ul>
            <nut-col :span="12" v-for='(item,i) in roadlist' :key="i">
              <li>
                <div class="top">
                  <div class="head">
                    <img @click="roaddetail(item.id)" v-if="item.imageUrl!='' && item.imageUrl != null" :src="item.imageUrl" />
                    <img @click="roaddetail(item.id)" v-else src="../assets/images/images/demomap.png" />

                  </div>
                  <div class="detail">
                    <h3 @click="roaddetail(item.id)">
                      <!-- <span v-for='(list,j) in item.tourRoutes' :key='j'>{{list.name}}<i>-</i></span> -->
                      <span>{{item.tourRoutes[0].name}}<i>--</i></span>
                      <span>{{item.tourRoutes[item.tourRoutes.length-1].name}}</span>
                    </h3>
                    <dl>
                      <span>top{{(page.currentPage-1)*10+i+1}}</span>
                      <span>{{item.userName}}</span>
                    </dl>

                  </div>
                </div>
                <div class="bottom">
                  <!-- <span>{{item.voteNum}}票</span> -->
                  <div class="btn1">
                    <dd class="vote1" @click="vote(item.id)" v-if='item.isVote==0'><span>{{item.voteNum}}</span></dd>
                    <dd class="vote1 voted" v-else-if='item.isVote!=0'><span>{{item.voteNum}}</span></dd>
                    <dd class="fare1" @click="share(item.tourRoutes[0].tourID)"><span>转发</span></dd>
                  </div>
                </div>
              </li>
            </nut-col>
          </ul>
          <el-pagination small @current-change='currentchange' layout="prev, pager, next" :total="page.count">
          </el-pagination>
        </div>

      </div>
      <!-- <div class="myroad roadbtn" @click="myroad()">
        <img src="../assets/images/button_wdxl.png" width="190" alt="" />
      </div> -->
    </div>
    <div class="gif">
      <!-- <nut-drag :boundary="{ top: 0, left: 0, bottom: bottom(), right: right() }" @click.native="gift" :class="drag?'drag':''">
        <div class="touch-dom"><img src="../assets/images/images/liwu.png" alt=""></div>
      </nut-drag> -->
      <div @click="gift" class="nut-drag drag">
        <div class="touch-dom"><img src="../assets/images/images/liwu.png" alt=""></div>
      </div>
      <div @click="rule" class="nut-drag1 drag">
        <div class="touch-dom"><img src="../assets/images/images/guize.png" alt=""></div>
      </div>
    </div>
    <el-dialog :visible.sync="logDialog" width="70%" title="" :show-close="false">
      <el-row>
        <p>请先登录</p>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="logDialog = false">取 消</el-button>
        <el-button size="small" type="danger" @click="login">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { API_1, Global } from "../conf/api";
import { library } from "../tools/tools";
import "../assets/css.css";

export default {
  data() {
    return {
      option: "选择主题",
      isVisible: false,
      logDialog: false,
      listData: [[]],
      search: {
        name: "",
      },
      address: {
        i: 0,
        imageUrl: "",
        theme: [],
        themeval: "",
        description: "",
        tourTime: "",
        startProvince: "",
        startCity: "",
        longitude: "",
        latitude: "",
        userID: "",
        userName: "",
        userHeadImage: "",
        routes: [""],
        tourRoutes: [
          {
            province: "",
            city: "",
            longitude: "",
            latitude: "",
            name: "",
            orderNum: "",
            tourID: "",
          },
        ],
      },
      token: "",
      userid: "",
      userimg: "",
      username: "",
      currtheme: "", //当前主题
      roadlist: [],
      capitals: [], //坐标组
      page: {
        currentPage: 1,
        count: 0,
        pageSize: 10,
      },
      voteSingleNum: 0,
      tourSum: 0, //多少人制定了线路
      submitbtn: true,
      hide: false,
      drag: false,
      imagesList: [],
      tuijian: [], //优质推荐
    };
  },

  mounted() {
    this.axios
      .get("https://api.ccmapp.cn/apis/resource/travailtable/get", {
        params: {
          token: "5f923627d58d1e41afa8cca9",
          data: library.safeEncodeBase64({
            condition: {
              platform:
                this.$route.query.platform == undefined
                  ? "CCMAPP-APP"
                  : this.$route.query.platform,
            },
            range: {
              structure: 1,
              data: 1,
              total: 1,
            },
            content: "",
            sort: {
              _id: -1,
            },
            pagination: {
              pageSize: 20,
              currentPage: 1,
            },
          }),
        },
      })
      .then((res) => {
        this.sortByKey(res.data.data.list, "desc");
        this.imagesList = res.data.data.list;
      });
    if (this.$route.query.mobilephone != undefined) {
      this.autoLog();
    } else {
      this.init();
    }
    let $this = this;
    window.addEventListener("scroll", function () {
      $this.showgift();

      //  let div = document.querySelector(".touch-dom");
      //  drag(div);
    });
  },
  watch: {
    $route: function (to, from) {
      this.init();
    },
  },
  methods: {
    toH5(url) {
      var u = navigator.userAgent;
      if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
        //ios
        window.location = url;
      } else if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
        //android
        location.href = url;
      }

      setTimeout(function () {
        window.location = url;
      }, 0);
      // this.$router.push({
      //   path: "/iframe",
      //   query: {
      //     url: url,
      //   },
      // });
    },
    login() {
      this.$router.push({
        path: "/login",
        query: {
          platform: this.$route.query.platform,
        },
      });
    },
    submitSearch() {
      console.log(this.page.currentPage);
      this.listTour("", this.currtheme, "", this.search.name);
      // let params = {
      //   searchUserID: this.userid,
      //   searchTheme: this.address.themeval,
      //   searchMine: "",
      //   searchUserName: this.search.name,
      //   pageSize: this.page.pageSize,
      //   currentPage: 1,
      // };
      // this.axios
      //   .get(
      //     "https://dev.ccmapp.cn/preview/api-cms-production/cms/production/tour/listTour",
      //     { params: params }
      //   )
      //   .then((res) => {
      //     this.roadlist = res.data.data;
      //     this.page.count = res.data.count;
      //     console.log(res, this.roadlist);
      //   });
    },
    openSwitch(param) {
      this[`${param}`] = true;
    },
    closeSwitch(param) {
      this[`${param}`] = false;
    },

    confirm(chooseData) {
      this.option = `${chooseData[0].value}`;
      if (chooseData[0].value == "全部") {
        this.currtheme = "";
      } else {
        this.currtheme = chooseData[0].value;
      }
      console.log(chooseData, this.option);
    },
    sortByKey(array, key) {
      return array.sort(function (a, b) {
        var x = a[key];
        var y = b[key];
        return x < y ? -1 : x > y ? 1 : 0;
      });
    },
    roadvote() {
      window.scrollTo(0, 800);
    },
    right() {
      return document.documentElement.clientWidth - 300 - 9;
    },
    bottom() {
      return document.documentElement.clientHeight - 601;
    },
    showgift() {
      this.drag = true;
    },
    hidegift() {
      this.drag = false;
    },
    gift() {
      if (this.$route.query.token == undefined) {
        this.logDialog = true;
      } else {
        if (this.userid != "") {
          this.$router.push({
            name: "Home",
            query: {
              userId: this.userid,
              userName: this.username,
            },
          });
        }
      }
    },
    rule() {
      this.$router.push({
        name: "activeRule",
      });
    },
    autoroad() {
      this.$router.push({
        path: "/auto",
        query: {
          token:
            this.$route.query.token == undefined
              ? "5caa9797156ae251cdb7def2"
              : this.token,
          needLog: this.$route.query.token == undefined ? "log" : "",
          platform: this.$route.query.platform,
        },
      });
    },
    makeroad() {
      this.$router.push({
        path: "/road",
        query: {
          token:
            this.$route.query.token == undefined
              ? "5caa9797156ae251cdb7def2"
              : this.token,
          uid: this.userid,
          needLog: this.$route.query.token == undefined ? "log" : "",
          platform: this.$route.query.platform,
        },
      });
    },
    autoLog() {
      let params = {
        appkey: "f1wgwXrHilsYew7iOSusc9NBwtCHe5ns",
        from: "CCMAPP-APP",
        mobilephone: this.$route.query.mobilephone,
        workspace: "5ba08a598a8691c371bea451",
      };
      this.axios
        // .get("https://testapi.ccmapp.cn/apis/core/internal/loginbymobilephone", { params: params })
        .get("https://api.ccmapp.cn/apis/core/internal/loginbymobilephone", {
          params: params,
        })
        .then((res) => {
          if (res.data.code != "200") {
            this.$toast.text(res.data.msg);
          } else {
            // 自动登录跳转页面
            this.$toast.text(res.data.message);
            this.token = res.data.data.token;
            this.$router.push({
              path: "/",
              query: {
                token: this.token,
                platform: this.$route.query.platform,
              },
            });
          }
        });
    },
    async init() {
      let params = this.$route.query;
      this.token = params.token;
      if (this.$route.path != "auto") {
        if (document.getElementsByClassName("amap-sug-result").length > 0) {
          document
            .getElementsByClassName("amap-sug-result")
            .forEach((item, index) => {
              item.style.setProperty("display", "none", "important");
            });
        }
      }
      console.log("init1");
      await this.axios
        .get("https://www.ccmapp.cn/middleware/userextrainfo", {
          // .get("https://testapi.ccmapp.cn:15400/middleware/userextrainfo", {
          params: {
            token:
              this.$route.query.token == undefined
                ? "5caa9797156ae251cdb7def2"
                : this.token,
          },
        })
        .then((res) => {
          this.username = res.data.data.user.realname;
          this.userimg = res.data.data.user.photo;
          this.userid = res.data.data.user._id;
        });
      //this.getlocation(0);
      console.log("init2");
      this.axios //主题获取
        // .get("http://172.10.103.61:15000/" + Global.themelist, {
        .get("https://api.ccmapp.cn/" + Global.themelist, {
          params: {
            token:
              this.$route.query.token == undefined
                ? "5caa9797156ae251cdb7def2"
                : this.token,
            type: "touristSoutes",
            system: 0,
            key: "",
            pagination: "eyJjdXJyZW50UGFnZSI6MSwicGFnZVNpemUiOjEwfQ",
            order: "-1",
            appid: "5e71964899aa8917f1e97c58",
          },
        })
        .then((res) => {
          console.log(res);
          this.address.theme = res.data.data.list;
          res.data.data.list.map((res, i) => {
            let obj = {};
            obj.label = i;
            obj.value = res.dictext;
            this.listData[0].push(obj);
          });
          this.address.theme.sort(function (a, b) {
            return a.order - b.order;
          });
        });

      this.axios
        .get("https://api.ccmapp.cn/apis/resource/youzhituijian/get", {
          params: {
            token: "5fa4a8ec55fd20c5141400f4",
            data: library.safeEncodeBase64({
              condition: {
                platform: this.$route.query.platform,
              },
              range: {
                structure: 1,
                data: 1,
                total: 1,
              },
              content: "",
              sort: {
                _id: -1,
              },
              pagination: {
                pageSize: 20,
                currentPage: 1,
              },
            }),
          },
        })
        .then((res) => {
          console.log(res);
          this.sortByKey(res.data.data.list, "desc");
          this.tuijian = res.data.data.list;
        });
      this.listTour("", "", "");
    },
    themelist(theme) {
      this.currtheme = theme;
      this.page.currentPage = 0;
      this.listTour("", theme, "");
    },
    currentchange(val) {
      //分页
      console.log(val);
      this.page.currentPage = val;
      this.listTour("", this.currtheme, "", this.search.name);
    },
    listTour(id, name, mine, peoplename) {
      let params = {
        searchUserID: this.userid,
        searchTheme: name,
        searchMine: "",
        searchUserName: peoplename,
        pageSize: this.page.pageSize,
        currentPage: this.page.currentPage,
      };
      this.axios
        .get(API_1 + Global.listTour, { params: params })
        .then((res) => {
          this.roadlist = res.data.data;
          this.page.count = res.data.count;
          console.log(res, this.roadlist, mine);
        });
    },
    vote(id) {
      if (this.$route.query.token == undefined) {
        this.logDialog = true;
      } else {
        this.axios
          .get(API_1 + Global.vote, {
            params: { id: id, userID: this.userid },
          })
          .then((res) => {
            console.log(res, "vote");
            this.voteSingleNum++;
            localStorage.setItem("voteSingleNum", this.voteSingleNum);
            this.listTour("", this.currtheme, "");
          });
      }
    },
    share(tid) {
      if (this.$route.query.token == undefined) {
        this.logDialog = true;
      } else {
        this.axios
          .get(API_1 + Global.share, {
            params: { userID: this.userid, tourID: tid },
          })
          .then((res) => {
            console.log(res, "share");
            if (res.data.code == 200) {
              console.log(this.roadlist, "lis");
              this.roadlist.map((item) => {
                if (item.id == tid) {
                  console.log(item);
                  let title = "";
                  item.tourRoutes.map((i, index) => {
                    if (item.tourRoutes.length - 1 == index) {
                      title += i.name;
                    } else {
                      title += i.name + "-";
                    }
                  });
                  window.location.href =
                    "/roadmap?option=share&shareDescription=" +
                    item.description +
                    "&shareImage=https://testapi.ccmapp.cn/apis/file/dl/source/5f7157b3c182cd5ca4ab5e22.png&shareTitle=" +
                    title +
                    // "&shareUrl=https://apps.ccmapp.cn/dist#/roadmap?tourid=" +
                    "&shareUrl=https://apps.ccmapp.cn/dist/jump.html?tourid=" +
                    tid +
                    "&currentPage=" +
                    this.page.currentPage +
                    "$theme=" +
                    this.currtheme;
                }
              });
            }
          });
      }
    },
    roaddetail(id) {
      this.$router.push({
        path: "/roadmap",
        query: {
          token:
            this.$route.query.token == undefined
              ? "5caa9797156ae251cdb7def2"
              : this.token,
          needLog: this.$route.query.token == undefined ? "log" : "",
          platform: this.$route.query.platform,
          uid: this.userid,
          tourid: id,
          currentPage: this.page.currentPage,
          theme: this.currtheme,
        },
      });
    },
    myroad() {
      if (this.$route.query.token == undefined) {
        this.logDialog = true;
      } else {
        this.$router.push({
          path: "/myroad",
          query: {
            token: this.token,
            uid: this.userid,
          },
        });
      }
    },
    showtit() {
      this.hide = !this.hide;
    },
  },
};
</script>

<style>
.box3 .li{ width: calc(50% - 0px); padding:0 5px;}
.nut-textinput-clear{ width: 20px !important;}
.nut-cell .nut-cell-right{ flex: 1;}
.nut-cell .nut-cell-right span{ width: 100% !important; text-align: left !important;}
.nut-cell .nut-cell-right span.nut-cell-icon{ display: none;}
.nut-cell .nut-cell-left{ flex: 0 !important;}
.search{ padding: 0 10px; overflow: hidden;}
.search .my-input{ width: 40%; float: left;}
.search .searchBtn{ font-size: 14px; width: 20%; float: left; border-radius: 5px; height: 40px; line-height: 40px; background: rgb(53,133,108);color: #fff;}
.search .my-input input{ width: 100%; color: #333;}
.search .nut-cell{ height: 40px !important; background: #fff !important; border: 1px solid #dddfe6;  width: 32%; margin: 0 10px; border-radius: 5px; float: left;}
.roadlist ul.el-pager{ padding: 0;}
.roadlist ul{ overflow: hidden; padding: 0 5px;}
.roadlist ul .nut-col li{ position: relative; margin: 0 5px; margin-bottom: 10px; background:rgb(235,251,241); height: 194px; border-radius: 4px; overflow: hidden;}
.roadlist ul li .head img{ height: 100px;}
.roadlist ul li .detail{ text-align: left;}
.roadlist ul li .detail h3{ font-size: 15px; padding: 5px;white-space: nowrap; text-overflow: ellipsis; overflow: hidden;}
.roadlist ul li .detail dl{ font-size: 15px; padding: 0 5px; height: 20px; overflow: hidden;}
.roadlist ul li .detail dl  span{ padding-right: 10px;}
.btn1{ display: flex; padding:10px 5px;}
.btn1 dd{ flex: 1; height: 24px; line-height: 24px;}
.btn1 dd.vote1{ background:url(../assets/images/images/zan-icon.svg) no-repeat; background-size: 22px; font-size: 16px; padding-left: 22px; text-align: left; flex: 2; }
.btn1 dd.vote1 span{ font-weight: bold;}
.btn1 dd.voted span{ }
.btn1 dd.fare1{ background:url(../assets/images/images/fenxiang-icon.svg) right no-repeat; background-size: 22px; font-size: 0;}
.nut-swiper-slide a {
  display: block;
}
.nut-swiper{ height: 200px !important;}
.nut-drag {
  position: fixed;
  top: 20px;
  width: 80px;
  height: 80px;
  transition: 0.6s all ease;
  left: 100%;
}
.nut-drag1 {
  position: fixed;
  top: 83px;
  width: 80px;
  height: 80px;
  transition: 0.6s all ease;
  left: 100%;
}
.drag {
  left: calc(100% - 100px);
}
.roadbtn img {
  width: 190px;
}
.roadlist ul li .bottom {
  position: inherit;
}
.box2 {
  margin-bottom: 20px;
  margin-top: 30px;
}

.box2 ul {
  overflow: hidden;
}
.box2 ul li {
  width: 50%;
  float: left;
  padding: 0 10px;
  box-sizing: border-box;
  position: relative;
}
.box2 ul li img {
  width: 100%;
  height: 166px;
}
.box2 ul li p {
  font-size: 16px;
  text-align: center;
  padding-top: 5px;
  font-weight: bold;
  height: 30px;
  line-height: 30px;
  color: rgb(53,134,108);
}
.box{ background:url(../assets/images/images/border-mid.png) scroll 0 20px repeat-y #fff; background-size: contain; margin: 15px 0;
 position: relative;}
.box:before{ position: absolute; display: block; content: ""; height: 14px; width: 100%; top: -14px; left: 0; background:url(../assets/images/images/border-top.png) top no-repeat #fff; background-size: 100% 14px; border-radius: 5px 5px 0 0;}
.box:after{ position: absolute; display: block; content: ""; height: 15px; width: 100%; bottom: -15px; left: 0; background:url(../assets/images/images/border-bottom.png) top no-repeat #fff; background-size: contain; border-radius: 0 0 5px 5px;}
body {
  background: #fff !important;
}
.fr {
  float: right;
}

.box .titlist {
  padding: 10px 5px;
  overflow: hidden;
  height: 50px;
  box-sizing: content-box;
  color: rgb(102,102,102);
}
.box .titlist.auto {
  height: auto;
}
.box .titlist span {
  display: block;
  width: 25%;
  text-align: center;
  float: left;
  margin-bottom: 10px;
  font-size: 14px;
}
.box .titlist span.on{ font-weight: bold;}
h3.tit {
  font-size: 18px;
  text-align: center;
  padding: 0 10px;
  margin: 10px 0 0px 0;
color: rgb(53,134,108);
font-weight: bold;
background: url(../assets/images/images/title.png) center no-repeat;
background-size: 90%;
height: 45px; line-height: 35px;
}
h3.tit span {
  font-size: 14px;
  color: blue;
}
.flex-content {
  text-align: center;
  margin: 15px 0;
}
.box3 .flex-content{ margin: 0;}
.box3 > div{ display: -webkit-box; overflow-x: auto; margin: 0 10px;}
.box3 > div .nut-col{ float: none; padding: 0 5px;}
.flex-content img {
 
}
.flex-content p {
  padding-top: 10px;
  font-size: 15px;
}
/* .amap-sug-result {
  display: none !important;
} */
.main{ background: rgb(235,251,241);}
.touch-dom img{ width: 93px;}
</style>
